import moment from "moment";
import { callApi, API_ROOT, getAccessToken } from "../api";

export const fetchGetWithdrawals = (cuenta, filter) => {
  const { desde, hasta, numCli, estatus } = filter;
  const from = moment(desde).format("YYYY-MM-DD");
  const to = moment(hasta).format("YYYY-MM-DD");
  const accNumber = numCli;
  const status = estatus !== "Todos" ? estatus : "All";

  return callApi(`accounts/${cuenta}/withdrawals?from=${from}&to=${to}&status=${status}`, null, "GET");
};

export const fetchGetDeposits = (cuenta, filter) => {
  const { desde, hasta, numCli, estatus } = filter;
  const from = moment(desde).format("YYYY-MM-DD");
  const to = moment(hasta).format("YYYY-MM-DD");
  const accNumber = numCli;
  const status = estatus !== "Todos" ? estatus : "All";

  return callApi(`accounts/${cuenta}/deposits?from=${from}&to=${to}&status=${status}`, null, "GET");
};

export const fetchAddWithdrawal = (cuenta, withdraw) =>
  callApi(`accounts/${cuenta}/withdrawals`, { withdraw }, "POST");

export const fetchIO = (io, k2btrnmode) => callApi(`inout`, { io, k2btrnmode }, "POST");

export const fetchUploadIOAttachments = (body) => {
  const { id, ioType, files } = body;

  const fullUrl = `${API_ROOT}inout/uploadAttachments/${id}?ioType=${encodeURI(ioType)}`;

  return fetch(fullUrl, {
    headers: {
      Authorization: getAccessToken(),
    },
    method: "POST",
    body: files,
  });
};

export const fetchDepositableAccounts = () => callApi(`deposit/depositableAccounts`, null, "GET");

export const fetchOffers = (accountId) => callApi(`offers/${accountId}`, null, "GET");

export const takeOffer = (body) => callApi(`offers`, body, "POST");

export const getEarnings = (body) => callApi(`earnings`, body, "POST");

export const getOrders = (body) => callApi(`orders`, body, "POST");

export const askPrice = (body) => callApi(`quote`, body, "POST");

export const fetchFunds = (accountId) =>
  callApi(`fundstoinvest`, { accountId, timezone: Intl.DateTimeFormat().resolvedOptions().timeZone }, "POST");

export const updateFund = (body) => callApi(`funds`, body, "POST");

export const getPrechecks = (body) => callApi(`prechecks`, body, "POST");
